import React from 'react';
import { canvasBackgroundColor } from '../styles/SharedStyles';
import { useThemeContext } from '../context';

export interface RouteWrapperProps {
  children?: any;
}

export function RouteWrapper({ children }: RouteWrapperProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <div
      style={{ backgroundColor: canvasBackgroundColor(theme), height: '100%' }}
    >
      {children}
    </div>
  );
}
